import styled from 'styled-components';

// A zero flex-basis keeps a long unbroken name from widening the flex cell it sits in; max-content keeps short names hugging their text.
const TruncatedText = styled.div`
  flex: 1 1 0;
  min-width: 0;
  max-width: max-content;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export default TruncatedText;
